<mat-card flex="100" *ngIf="pilot$ | async; let pilot">
  <mat-card-title>
    {{ pilot.firstName }} {{ pilot.middleName }} {{ pilot.lastName }}
    <button class="edit-button" mat-raised-button routerLink="./edit">
      <mat-icon>edit</mat-icon>Edit
    </button>
    <button class="bulk-update-button" mat-raised-button (click)="bulkUpdate(pilot.id)">
      <mat-icon>list</mat-icon>Update Entities Processing State
    </button>
  </mat-card-title>
  <mat-card-subtitle>{{ airCarrier?.abbreviation }} Pilot</mat-card-subtitle>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div class="detail-section">
      <div>
        <span class="label">First Name:</span>
        <span class="value">{{ pilot.firstName }}</span>
      </div>
      <div>
        <span class="label">Middle Name:</span>
        <span class="value">{{ pilot.middleName }}</span>
      </div>
      <div>
        <span class="label">Last Name:</span>
        <span class="value">{{ pilot.lastName }}</span>
      </div>
      <div>
        <span class="label">Certificate Number:</span>
        <span class="value">{{ pilot.certificateNumber }}</span>
      </div>
      <div>
        <span class="label">Processing State:</span>
        <span class="value">{{ pilot.processingState | humanize }}</span>
      </div>
      <div>
        <span class="label">Last Processed Date:</span>
        <ng-container *ngIf="pilot.lastProcessedDate; else notAvailable">
          <span class="value">{{
            (pilot.lastProcessedDate | date : 'MM/dd/yyyy HH:mm') || '--'
          }}</span>
        </ng-container>
      </div>
      <div>
        <span class="label">Processing Error:</span>
        <ng-container *ngIf="pilot.processingError; else notAvailable">
          <span class="value prd-processing-error-text">{{ pilot.processingError }}</span>
        </ng-container>
      </div>
      <div>
        <span class="label">Hidden:</span>
        <span class="value">{{ pilot.hidden | yesNo }}</span>
      </div>
      <ng-template #notAvailable>
        <span class="value">N/A</span>
      </ng-template>
      <mat-tab-group (selectedTabChange)="setActiveTab($event)">
        <mat-tab label="Employment Records">
          <fl-pilot-employment-records-list
            *ngIf="activeTab === 0"
            [pilotId]="pilot.id"
          ></fl-pilot-employment-records-list>
        </mat-tab>
        <mat-tab label="Training Records">
          <fl-pilot-training-records-list
            *ngIf="activeTab === 1"
            [pilotId]="pilot.id"
          ></fl-pilot-training-records-list>
        </mat-tab>
        <mat-tab label="Final Disciplinary Actions">
          <fl-pilot-final-disciplinary-actions-list
            *ngIf="activeTab === 2"
            [pilotId]="pilot.id"
          ></fl-pilot-final-disciplinary-actions-list>
        </mat-tab>
        <mat-tab label="NDR Records">
          <fl-pilot-ndr-records-list
            *ngIf="activeTab === 3"
            [pilotId]="pilot.id"
          ></fl-pilot-ndr-records-list>
        </mat-tab>
        <mat-tab label="Drug and Alcohol Records">
          <fl-pilot-drug-alcohol-records-list
            *ngIf="activeTab === 4"
            [pilotId]="pilot.id"
          ></fl-pilot-drug-alcohol-records-list>
        </mat-tab>
      </mat-tab-group>
      <button class="back-button" mat-raised-button routerLink="..">
        <mat-icon>arrow_back</mat-icon>Back
      </button>
    </div>
  </mat-card-content>
</mat-card>
